var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandsWithHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Donation-Charity-Hand-Care-Heart--Streamline-Ultimate",
    clipPath: "url(#clip0_32745_17426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.4452 21.8063L11.8469 11.793C11.0044 10.9497 10.4483 9.86297 10.2571 8.68638C10.066 7.50979 10.2496 6.30289 10.7819 5.23632C11.184 4.43106 11.7718 3.7329 12.4967 3.19937C13.2216 2.66585 14.0629 2.31224 14.9513 2.1677C15.8398 2.02316 16.7498 2.09182 17.6065 2.36803C18.4631 2.64423 19.2419 3.12007 19.8785 3.75632L21.4452 5.32299L23.0135 3.75632C23.6497 3.11988 24.428 2.64375 25.2843 2.36716C26.1406 2.09058 27.0504 2.02146 27.9386 2.16552C28.8269 2.30957 29.6682 2.66267 30.3932 3.19571C31.1182 3.72874 31.7061 4.42645 32.1085 5.23132C32.6415 6.29761 32.8256 7.50453 32.6348 8.68123C32.444 9.85793 31.8879 10.9448 31.0452 11.788L21.4452 21.8063Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.875 39.0896L3.51834 35.1146C2.45313 33.783 1.87349 32.1281 1.875 30.4229V21.8096C1.875 21.1465 2.1384 20.5106 2.60724 20.0418C3.07608 19.573 3.71196 19.3096 4.375 19.3096C5.03804 19.3096 5.67393 19.573 6.14277 20.0418C6.61161 20.5106 6.875 21.1465 6.875 21.8096V28.0596",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.3749 39.0895V34.0895C14.3755 32.6064 13.9365 31.1564 13.1132 29.9229L11.2099 27.0662C11.0473 26.7955 10.8316 26.5606 10.5756 26.3758C10.3197 26.191 10.0289 26.06 9.7208 25.9908C9.41275 25.9216 9.09387 25.9157 8.78345 25.9733C8.47304 26.031 8.17755 26.151 7.91488 26.3262C7.44197 26.6415 7.10042 27.1186 6.95435 27.6679C6.80827 28.2172 6.86773 28.8009 7.12155 29.3095L9.37488 33.0595",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.375 39.0896L37.7317 35.1212C38.7983 33.7879 39.378 32.1304 39.375 30.4229V21.8096C39.375 21.1465 39.1116 20.5106 38.6428 20.0418C38.1739 19.573 37.538 19.3096 36.875 19.3096C36.212 19.3096 35.5761 19.573 35.1072 20.0418C34.6384 20.5106 34.375 21.1465 34.375 21.8096V28.0596",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.875 39.0896V34.0896C26.8743 32.6065 27.3134 31.1565 28.1367 29.9229L30.04 27.0696C30.2025 26.7989 30.4183 26.5641 30.6743 26.3792C30.9302 26.1944 31.221 26.0634 31.5291 25.9942C31.8371 25.925 32.156 25.9191 32.4664 25.9767C32.7768 26.0344 33.0723 26.1544 33.335 26.3296C33.8079 26.6449 34.1495 27.122 34.2955 27.6713C34.4416 28.2206 34.3822 28.8044 34.1283 29.3129L31.875 33.0629",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32745_17426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.625 0.5896)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsWithHeart);
export default __webpack_public_path__ + "static/media/handsWithHeart.8be3c1afce30da8dfda5ba9111f35c1f.svg";
export { ForwardRef as ReactComponent };